export default "__VITE_ASSET__qn3pOMlk__"